import PillarRelatedReading from './PillarRelatedReading'

export default PillarRelatedReading